import { TypographyProps } from '@mui/material';
import Typography from '@mui/material/Typography';

export const AddToWishlistTypography = (props: TypographyProps) => {
  return <Typography {...props}>Add brands & categories to your Wishlist</Typography>;
};
